import { Provider } from '../../types';
import { getData, postData } from '../../utils/service';
import { Role, Scope } from './types';
export const PROVIDER_ROUTES = {
  get: '/providers',
  patch: '/providers/{provider_id}',
  post: '/providers',
};

export const EMPLOYER_USER_ROUTES = {
  post: '/employer-users',
  get: '/employer-users',
};

export const USER_ROUTES = {
  post: '/user-roles',
  get: '/user-roles/for_current_user',
};

export const getOrCreateProvider = async () => {
  return await getData('provider');
};

export const getOrCreateEmployer = async () => {
  return await getData('employerUser');
};

export const createUserRole = async ({ input }: { input: Scope }) => {
  const provider = (input as Scope).context?.provider as Provider;
  let userId: number | undefined = provider?.userInfo?.id;
  const roleCode: Role = (input as Scope).context.role || 'PROVIDER';
  if (roleCode === 'EMPLOYER') {
    userId = (input as Scope).context?.employerUser?.userInfoId;
  }
  if (!userId) {
    throw new Error('No user id found');
  }
  return await postData('user', {
    data: { userId, roleCode: roleCode },
  });
};

export const getCurrentUserRoles = async () => {
  return await getData('user');
};

export interface RoleResponse {
  employerUserId?: number;
  providerId?: number;
  roleCode: 'PROVIDER' | 'EMPLOYER' | undefined;
  userInfoId: number;
  primaryEmail: string;
}

/**
 * Fetch provider by clerk user ID
 */
export const fetchUser = async (): Promise<RoleResponse | null> => {
  return await getData<RoleResponse>('userInfo', {});
};
